import { RouterState }     from "connected-react-router";
import React, {
  useEffect,
  useMemo,
  useState
} from "react";
import {
  useDispatch,
  useSelector
}                          from "react-redux";
import CameraListComponent from "../components/cameralist/CameraListComponent";

import { ApplicationState }        from "../store";
import { AlertState }              from "../store/alerts/types";
import { APIState }                from "../store/API/types";
import {
  bwsAddTimeStrips,
  startBrowsePane
}                                  from "../store/browse/actions";
import {
  setCameraListSearchQuery,
  setCameraReload,
  setCurrentCamera,
  setOpenedCameraList
}                                  from "../store/cameras/actions";
import { CamerasState }            from "../store/cameras/types";
import { setCurrentLayoutChanged } from "../store/layouts/actions";
import { transformCayugaData }     from "../store/sagas/utils";
import { SettingsState }           from "../store/settings/types";
import {
  setPlaybackmode,
  setTimelineDate
}                                  from "../store/timeline/actions";
import { Routes }                  from "../types";
import {
  chooseService,
  filterCamerasBySearchQuery,
  getLocalBounds
}                                  from "../utils";

interface Props {
  pane: number
}

const CameraListContainer: React.FC<Props> = ({pane}) => {
  const {cameras} = useSelector<ApplicationState, APIState>(state => state.API);
  const {openedCameraList, currentCameras, cameraListSearchQuery} = useSelector<ApplicationState, CamerasState>(state => state.cameras);
  const {clearTextAfterSelection} = useSelector<ApplicationState, SettingsState>(state => state.settings);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const {selectedEvent} = useSelector<ApplicationState, AlertState>(state => state.alerts);
  const [typedValue, setTypedValue] = useState<string>(cameraListSearchQuery);

  const isBrowse = location.pathname === Routes.browse;
  const isAlerts = location.pathname === Routes.alerts;

  const currentSearchCameras = useMemo(() => isAlerts
    ? transformCayugaData(selectedEvent?.cameras && selectedEvent.cameras.filter((c: any) => {
      let isPresent = false;
      cameras.forEach((c2: any) => {
        if (c2.name === c['a:Name']) {
          return isPresent = true;
        }
      });
      return isPresent;
    })) : cameras, [selectedEvent, cameras]);

  const [filteredCameras, setFilteredCameras] = useState(filterCamerasBySearchQuery(currentSearchCameras, typedValue));

  const dispatch = useDispatch();

  const currentCamera = currentCameras[pane];

  const searchHandler = (event: React.FormEvent<HTMLInputElement>): void => {
    event.stopPropagation();
    const val = event.currentTarget.value;

    const cams = filterCamerasBySearchQuery(currentSearchCameras, val);

    val.length > 0 ? setFilteredCameras(cams) : setFilteredCameras(currentSearchCameras);
    setTypedValue(val);
    dispatch(setCameraListSearchQuery(val));
  };

  const onCameraSelect = (name: string) => {
    if (clearTextAfterSelection) setTypedValue('');
    const checkedCamera = cameras.filter((camera: any) => camera.name === name)[0];
    if (location.pathname === Routes.live) {
      dispatch(setCurrentLayoutChanged());
    }
    if (isAlerts) {
      chooseService(
        () => {
        },
        () => {
          const alertBrowsePane = document.getElementById('thumbnail-0');
          const {width, height} = getLocalBounds(alertBrowsePane);
          const {error, stream} = {error: false, stream: {stream_id: ''}};
          if (!error && checkedCamera) {
            dispatch(startBrowsePane({
              pane: pane,
              width: Math.floor(width),
              height: Math.floor(height),
              camId: checkedCamera.id,
              streamId: stream.stream_id
            }));
          }

          if (selectedEvent?.when) dispatch(setTimelineDate(parseInt(selectedEvent.when)));
          dispatch(setOpenedCameraList(false));
        }
      )
    } else {
      if (currentCamera && currentCamera.name === name) {
        dispatch(setCameraReload(pane));
        return dispatch(setOpenedCameraList(false));
      }

      dispatch({type: 'cancelDeviceStatus'});
      dispatch(setCurrentCamera(checkedCamera, pane));
      if (isBrowse) {
        dispatch(setPlaybackmode('pause'));
        dispatch(bwsAddTimeStrips(pane, [], null));
      }
    }
  };

  useEffect(() => {
    if (clearTextAfterSelection) {
      setTypedValue('');
      dispatch(setCameraListSearchQuery(''));
      setFilteredCameras(
        chooseService(
          () => isBrowse ? cameras.filter((cam: any) => cam.can_browse) : cameras,
          () => currentSearchCameras
        )
      );
    }
  }, [openedCameraList]);

  useEffect(() => {
    if (location.pathname === Routes.alerts) {
      setFilteredCameras(
        chooseService(
          () => cameras,
          () => currentSearchCameras
        )
      );
    }
  }, [selectedEvent]);

  return (
    <CameraListComponent
      openedCameraList={openedCameraList}
      searchHandler={searchHandler}
      pane={pane}
      cameras={filteredCameras}
      typedValue={typedValue}
      onCameraSelect={onCameraSelect}
    />
  )
};

export default CameraListContainer;
